import { WarningCircleIcon } from '@phosphor-icons/react'
import { ScoopTextField } from '../../../../../ui'
import { ScoopSpinner } from '../../../../../ui'
import { ConfigurationSummary } from '../ConfigurationSummary/ConfigurationSummary'
import styles from './RefinementChat.module.scss'

/**
 * Displays the refinement phase with configuration summary
 * All action buttons are handled by the parent in dialog footer
 * @param {Object} props
 * @param {Object} props.conversation - Current conversation state
 * @param {string} props.datasetName - Dataset name for the new dataset
 * @param {Function} props.onDatasetNameChange - Callback when dataset name changes
 * @param {boolean} props.loading - Loading state
 */
export const RefinementChat = ({
    conversation,
    datasetName,
    onDatasetNameChange,
    startDate,
    onStartDateChange,
    requireDateRange,
    requireObjectSelection,
    objectList,
    objectSelectionLabel,
    selectedObjectName,
    onObjectChange,
    loading,
}) => {
    const isConvergenceWarning = conversation?.phase === 'CONVERGENCE_WARNING'

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <ScoopSpinner size={40} />
                <span className={styles.loadingText}>Updating configuration...</span>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Here's the configuration I recommend:</h3>

            <ConfigurationSummary
                objectLabel={conversation?.objectLabel}
                fieldLabels={conversation?.fieldLabels || []}
                filters={conversation?.filters || []}
                requireDateRange={requireDateRange}
                startDate={startDate}
                onStartDateChange={onStartDateChange}
                requireObjectSelection={requireObjectSelection}
                objectList={objectList}
                objectSelectionLabel={objectSelectionLabel}
                selectedObjectName={selectedObjectName}
                onObjectChange={onObjectChange}
                reasoning={conversation?.reasoning}
            />

            <div className={styles.datasetNameContainer}>
                <ScoopTextField
                    label="Dataset name"
                    value={datasetName}
                    onChange={(e) => onDatasetNameChange(e.target.value)}
                    placeholder="Enter a name for your dataset"
                />
            </div>

            {isConvergenceWarning && (
                <div className={styles.warningBanner}>
                    <WarningCircleIcon size={20} weight="fill" className={styles.warningIcon} />
                    <span>
                        We've been going back and forth a bit. Would you like to create with the
                        current config, configure manually, or start over?
                    </span>
                </div>
            )}

            {conversation?.modificationRound > 0 && (
                <span className={styles.roundIndicator}>
                    Round {conversation.modificationRound} of 5
                </span>
            )}
        </div>
    )
}
